import { AfterContentInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { db } from 'src/app/db/db';
import { MesureAdduction } from 'src/app/domain/Adduction-air/mesure-adduction';
import { MeasureEau } from 'src/app/domain/EAU/measure-eau';
import { EDegradationLevel } from 'src/app/domain/enums/degradation-level';
import { ELifeCycleStatus } from 'src/app/domain/enums/life-cycle-status';
import { EZoneType } from 'src/app/domain/enums/zone-type';
import { EZoneUsage } from 'src/app/domain/enums/zone-usage';
import { Intervention } from 'src/app/domain/intervention';
import { MeasureLingette } from 'src/app/domain/Lingette/measure-lingette';
import { MeasureMassif } from 'src/app/domain/Massif/measure-massif';
import { MeasureGeneric } from 'src/app/domain/measure-generic';
import { MPCA } from 'src/app/domain/mpca';
import { Process } from 'src/app/domain/process';
import { Zone } from 'src/app/domain/zone';
import { ZoneMeasure } from 'src/app/domain/zone-measure';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { mapper } from 'src/app/tools/mapping/mapper';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { AddMPCABoxDialog } from 'src/app/tools/ui/add-mpca-box/add-mpca-box';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { EditTextBoxDialog } from 'src/app/tools/ui/edit-text-box/edit-text-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { ProcessConformiteBoxDialog } from 'src/app/tools/ui/process-conformite-box/process-conformite-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { ZoneConformiteBoxDialog } from 'src/app/tools/ui/zone-conformite-box/zone-conformite-box';

@Component({
    selector: 'app-intervention',
    templateUrl: './intervention.component.html',
    styleUrls: ['./intervention.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InterventionComponent implements OnInit, AfterContentInit {

    private interventionCode: number | undefined;
    ZoneProcessList: Array<Zone | Process> = []
    Intervention!: Intervention;
    MeasureEauList: MeasureEau[] = [];
    MeasureMassifList: MeasureMassif[] = [];
    MeasureLingetteList: MeasureLingette[] = [];
    MeasureAdductionList: MesureAdduction[] = [];
    MeasureGenericList: MeasureGeneric[] = [];

    constructor(
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router) { }

    ngOnInit(): void {

    }

    async ngAfterContentInit(): Promise<void> {
        this.interventionCode = Number(this.route.snapshot.params?.['interventionCode']);
        // this.Intervention = await db.getInterventionWithOnlyContactByCode(this.interventionCode);
        this.Intervention = await db.getInterventionByCode(this.interventionCode)

        if (this.Intervention) {

            let processList = this.Intervention.ProcessList;
            if (processList) {
                this.ZoneProcessList.push(...processList);
            }

            this.ZoneProcessList.push(...this.Intervention.ZoneList);
            this.MeasureEauList.push(...this.Intervention.MesureEauList);
            this.MeasureLingetteList.push(...this.Intervention.MesureLingetteList);
            this.MeasureMassifList.push(...this.Intervention.MesureMassifList);
            this.MeasureAdductionList.push(...this.Intervention.MesureAdductionAirList)
            this.MeasureGenericList.push(...this.Intervention.MesureGeneriqueList)
        }
    }

    getMockedData() {
        this.ZoneProcessList.push(Object.assign(new Zone, {
            Id: 1, Position: 1, Usage: EZoneUsage.Environmental, Type: EZoneType.Indoor, MPCA: 'Colle collante',
            Measures: [
                { MeasureReference: { Name: 'M', Color: 'orange', TextColor: 'white' } },
                { MeasureReference: { Name: 'P', Color: 'yellow', TextColor: 'white' } },
                { MeasureReference: { Name: 'O', Color: 'red', TextColor: 'white' } }
            ]
        }));
        this.ZoneProcessList.push(Object.assign(new Zone, {
            Id: 2, Position: 2, Usage: EZoneUsage.PostWork, Type: EZoneType.Outdoor, MPCA: 'Colle pas collante',
            Measures: [{ MeasureReference: { Name: 'N', Color: 'green', TextColor: 'white' } },
            { MeasureReference: { Name: 'P', Color: 'yellow', TextColor: 'white' } }]
        }));
        this.ZoneProcessList.push(Object.assign(new Zone, {
            Id: 3, Position: 3, Usage: EZoneUsage.PreWork, Type: EZoneType.Indoor, MPCA: 'Colle de fou',
            Measures: [{ MeasureReference: { Name: 'O', Color: 'red', TextColor: 'white' } }]
        }));
        this.ZoneProcessList.push(Object.assign(new Zone, {
            Id: 4, Position: 4, Usage: EZoneUsage.Environmental, Type: EZoneType.Outdoor, MPCA: 'Colle amiantée',
            Measures: [
                { MeasureReference: { Name: 'P', Color: 'yellow', TextColor: 'white' } },
                { MeasureReference: { Name: 'Q', Color: 'black', TextColor: 'white' } }]
        }));
        this.ZoneProcessList.push(Object.assign(new Zone, {
            Id: 5, Position: 5, Usage: EZoneUsage.PostWork, Type: EZoneType.Indoor, MPCA: 'CoColle',
            Measures: [{ MeasureReference: { Name: 'Q', Color: 'black', TextColor: 'white' } }]
        }));
        this.ZoneProcessList.push(Object.assign(new Process, { Id: 1, Name: 'Retrait de colle', MeasureReference: { Name: 'J', Color: 'red', TextColor: 'white' } }));
        this.ZoneProcessList.push(Object.assign(new Process, { Id: 2, Name: 'Retrait de peinture', MeasureReference: { Name: 'K', Color: 'blue', TextColor: 'green' } }));
    }

    IsZone(zp: Zone | Process) {
        return zp instanceof Zone;
    }

    getColorByLingetteStatus(mL: MeasureLingette) {
        switch (mL.Status) {
            case ELifeCycleStatus.NotCompletedAndNotPositioned:
                return 'default !important';
            case ELifeCycleStatus.CompletedAndNotPositioned:
            case ELifeCycleStatus.CompletedAndPositionedNotSaved:
                return '#E59EDD !important';
            case ELifeCycleStatus.CompletedAndPositioned:
                return '#B4E5A2 !important';
        }
    }

    addNewMPCA(z: Zone) {
        const dialogRef = this.dialog.open(AddMPCABoxDialog, {
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async (result: MPCA) => {
            if (result) {

                const success = await db.addMPCAToZone(z, z.IsDepose, result);
                if (success) {
                    z.MpcaList.push(result);
                }
                NotificationManager.handleSuccess(success ? 'MPCA enregistrée' : 'Wasted Bro!', this.snackBar);
            }
        });

    }
    getDegradationLevelName(level: EDegradationLevel) {
        return StringConverter.getDegradationLevelName(level)
    }

    openZoneConformiteDialog(zone: Zone) {

        const dialogRef = this.dialog.open(ZoneConformiteBoxDialog, {
            data: zone,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async (result: Zone) => {
            if (result) {
                zone.BuildingType = result.BuildingType;
                zone.RoomUsage = result.RoomUsage;
                zone.MpcaList = result.MpcaList;
                zone.ActivitySimulation = result.ActivitySimulation;
                zone.Observation = result.Observation;
                zone.OnSiteProtectionAndSealingType = result.OnSiteProtectionAndSealingType;
                const success = await db.updateZoneForConformity(zone);
                NotificationManager.handleSuccess(success ? 'Conformité de la zone enregistrée' : 'Wasted Bro!', this.snackBar);
            }
        });
    }

    openProcessConformiteDialog(process: Process) {

        const dialogRef = this.dialog.open(ProcessConformiteBoxDialog, {
            data: process,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async result => {
            if (result) {
                mapper.mutate(result, process, Process, Process);
                const success = await db.updateProcessForConformity(process);
                NotificationManager.handleSuccess(success ? 'Conformité du processus enregistrée' : 'Wasted Bro!', this.snackBar);
            }
        });
    }

    openDispatchComment() {
        this.dialog.open(ConfirmBoxDialog, {
            data: {
                message: `${this.Intervention.Comment}`
            },
            width: '777px',
        });
    }

    hasCompletedZoneConformite(zone: Zone) {
        return zone.MpcaList.length > 0 && zone.BuildingType && zone.RoomUsage && zone.ActivitySimulation;
    }

    hasCompletedProcessConformite(process: Process) {
        return process.Name && process.SubSection && process.DustLoadType && process.VentilationGlobale && process.EnvCollectiveMeansOfPreventionList.length > 0 &&
            process.ProcessTechniqueList && process.ProcessTechniqueList.length > 0 &&
            process.ProcessTechniqueList.every(x => x.Catchment) && process.ProcessTechniqueList.every(x => x.ScolaTechnique) &&
            process.ProcessTechniqueList.every(x => x.Mpca.ScolaMaterial) && process.ProcessTechniqueList.every(x => x.Humidification) &&
            process.ProcessTechniqueList.every(x => x.HumidityWork)
    }

    navigateToZoneMeasure(zone: Zone, mrCode: string, isDepose: boolean) {
        // if (!this.hasCompletedZoneConformite(zone)) {
        //     this.openZoneConformiteDialog(zone);
        //     return;
        // }
        this.router.navigate([ENavigationRoute.ZoneMeasure, { zoneCode: zone.Code, measureCode: mrCode, isDepose: isDepose }]);
    }

    navigateToProcessMeasure(process: Process, mrCode: string, samplingMode: number) {
        // if (!this.hasCompletedProcessConformite(process)) {
        //     this.openProcessConformiteDialog(process);
        //     return;
        // }
        this.router.navigate([ENavigationRoute.ProcessMeasure, { processCode: process.Code, measureCode: mrCode, samplingMode: samplingMode }]);
    }

    navigateToMassifMeasure(code: string) {
        this.router.navigate([ENavigationRoute.MassifMeasure, { code: code, interventionCode: this.interventionCode }]);
    }

    navigateToEauMeasure(code: string) {
        this.router.navigate([ENavigationRoute.EauMeasure, { code: code }]);
    }

    navigateToLingetteMeasure(code: string) {
        this.router.navigate([ENavigationRoute.LingetteMeasure, { code: code, interventionCode: this.interventionCode }]);
    }

    navigateToMesureAdduction(code: string) {
        this.router.navigate([ENavigationRoute.Adduction, { code: code }]);
    }

    navigateToGeneric(code: string) {
        this.router.navigate([ENavigationRoute.Generics, { code: code }]);
    }

    navigateToDrawingMapTool(areaMapId: number, zp?: Zone | Process) {
        // if (zp instanceof Zone) {
        //     this.router.navigate([ENavigationRoute.DrawingTool, {
        //         interventionCode: this.interventionCode,
        //         areaMapId: areaMapId,
        //         zpCode: zp?.Code,
        //         isDepose: (zp as Zone).IsDepose
        //     }]);
        // } else {
        //     this.router.navigate([ENavigationRoute.DrawingTool, {
        //         interventionCode: this.interventionCode,
        //         areaMapId: areaMapId,
        //         zpCode: zp?.Code
        //     }]);
        // }

        this.router.navigate([ENavigationRoute.DrawingTool, {
            interventionCode: this.interventionCode,
            areaMapId: areaMapId,
            ...(zp ? { zpCode: zp.Code } : {}),
            ...(zp instanceof Zone ? { isDepose: zp.IsDepose } : {})
        }]);
    }

    IsDone(m: ZoneMeasure) {
        if (m.IsDepose)
            return m.Cassette.Integrite;
        return m.Cassette.Reference && m.Cassette.Pompe.Reference;
    }

    searchPompe() {
        const dialogRef = this.dialog.open(EditTextBoxDialog, {
            data: {
                title: 'Recherche de pompe/cassette',
                text: ''
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: string) => {
            if (result) {
                let z: Zone | undefined;
                let m: ZoneMeasure | undefined;

                this.ZoneProcessList.forEach(x => {

                    if (x instanceof Zone) {
                        if (x.ZoneMesureList.find(y => result === y.Cassette.Pompe.Reference || result === y.Cassette.Reference)) {
                            z = x;
                            m = x.ZoneMesureList.find(y => result === y.Cassette.Pompe.Reference || result === y.Cassette.Reference);
                        }
                    }
                })

                if (z && m)
                    this.navigateToZoneMeasure(z, m.Code, m.IsDepose)
            }
        });
    }

    getColorByInterventionIndex(zp: Zone | Process) {

        if (zp instanceof Zone) {
            return "goldenrod !important";
        } else if (zp instanceof Process) {
            return "indianred !important";
        }

        return "pink !important";
    }
}
